import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AssociateResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const associate = {
    record(data: typeof Requests.Associate.Record.Input) {
        return post<typeof data, AssociateResponseTypes.Record>(`/associate/record`, data);
    },
    create(data: typeof Requests.Associate.Create.Input) {
        return post<typeof data>(`/associate/create`, data);
    },
    obtain(id: string) {
        return get<AssociateResponseTypes.Obtain>(`/associate/obtain/${id}`);
    },
    enable(id: string) {
        return postEmpty(`/associate/enable/${id}`);
    },
    disable(id: string) {
        return postEmpty(`/associate/disable/${id}`);
    },
    resetOTP(id: string) {
        return postEmpty(`/associate/reset-otp/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<AssociateResponseTypes.Select>(
                `/associate/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Associate.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/associate/update/${id}`, data),
                    isLoading,
                );
            };
        },
        devUpdate(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Associate.Dev.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/dev/associate/update/${id}`, data),
                    isLoading,
                );
            };
        },
        initialCoord: async () => {
            return await get<AssociateResponseTypes.InitialCoord>(
                "/associate/initial-coord",
            ).execute();
        },
    },
    dev: {
        prune(id: string) {
            return postEmpty(`/dev/associate/prune/${id}`);
        },
        delete(id: string) {
            return postEmpty(`/dev/associate/delete/${id}`);
        },
        masquerade(id: string) {
            return get<AssociateResponseTypes.Masquerade>(`/dev/associate/masquerade/${id}`);
        },
    },
};
